// DXCC prefix-to-country lookup table.
// Entries are sorted longest-first so the most specific prefix wins.
// Covers all current ARRL DXCC entities.
// Usage: getDxCountry('JA1ZGP') => 'Japan'

const DXCC_PREFIXES = [
  // Sorted by prefix length descending for greedy matching
  // 4-character prefixes
  ['VP9', 'Bermuda'],
  ['VP8/G', 'South Georgia Is.'],
  ['VK9X', 'Christmas Is.'],
  ['VK9N', 'Nauru'],
  ['VK9M', 'Mellish Reef'],
  ['VK9L', 'Lord Howe Is.'],
  ['VK9C', 'Cocos-Keeling Is.'],
  ['VK0M', 'Macquarie Is.'],
  ['VK0H', 'Heard Is.'],
  ['VE1', 'Canada'],
  ['VD8', 'Brunei'],
  ['V73', 'Marshall Is.'],
  ['V63', 'Micronesia'],
  ['V47', 'St. Kitts & Nevis'],
  ['V31', 'Belize'],
  ['V26', 'Antigua & Barbuda'],
  ['V21', 'Antigua & Barbuda'],
  ['TZ6', 'Mali'],
  ['TT8', 'Chad'],
  ['TR8', 'Gabon'],
  ['TN8', 'Republic of Congo'],
  ['TL8', 'Central Africa'],
  ['TJ8', 'Cameroon'],
  ['TF3', 'Iceland'],
  ['ST0', 'South Sudan'],
  ['SV5', 'Dodecanese'],
  ['SV9', 'Crete'],
  ['SV/', 'Mount Athos'],
  ['PP0', 'Fernando de Noronha'],
  ['PY0F', 'Fernando de Noronha'],
  ['PY0T', 'Trindade & Martim Vaz Is.'],
  ['PY0S', 'St. Peter & St. Paul Rocks'],
  ['OX3', 'Greenland'],
  ['OA4', 'Peru'],
  ['OH0', 'Aland Is.'],
  ['OJ0', 'Market Reef'],
  ['KG4', 'Guantanamo Bay'],
  ['KH0', 'Mariana Is.'],
  ['KH1', 'Baker & Howland Is.'],
  ['KH2', 'Guam'],
  ['KH3', 'Johnston Is.'],
  ['KH4', 'Midway Is.'],
  ['KH5', 'Palmyra & Jarvis Is.'],
  ['KH6', 'Hawaii'],
  ['KH7', 'Kure Is.'],
  ['KH8', 'American Samoa'],
  ['KH9', 'Wake Is.'],
  ['KL7', 'Alaska'],
  ['KP1', 'Navassa Is.'],
  ['KP2', 'US Virgin Is.'],
  ['KP3', 'Puerto Rico'],
  ['KP4', 'Puerto Rico'],
  ['KP5', 'Desecheo Is.'],
  ['J3A', 'Grenada'],
  ['J37', 'Grenada'],
  ['J68', 'St. Lucia'],
  ['J75', 'Dominica'],
  ['J79', 'Dominica'],
  ['J87', 'St. Vincent'],
  ['FT5W', 'Crozet Is.'],
  ['FT5X', 'Kerguelen Is.'],
  ['FT5Z', 'Amsterdam & St. Paul Is.'],
  ['FO0', 'Clipperton Is.'],
  ['FM5', 'Martinique'],
  ['FJ/', 'St. Barthelemy'],
  ['FG5', 'Guadeloupe'],
  ['FF8', 'French Guinea'],
  ['FH8', 'Mayotte'],
  ['FR5', 'Reunion Is.'],
  ['FS5', 'St. Martin'],
  ['FW5', 'Wallis & Futuna Is.'],
  ['FO8', 'French Polynesia'],
  ['FK8', 'New Caledonia'],
  ['3DA', 'Swaziland'],
  ['3V8', 'Tunisia'],
  ['4W6', 'Timor-Leste'],
  ['5A1', 'Libya'],
  ['5B4', 'Cyprus'],
  ['5H3', 'Tanzania'],
  ['5N0', 'Nigeria'],
  ['5R8', 'Madagascar'],
  ['5T5', 'Mauritania'],
  ['5U7', 'Niger'],
  ['5V7', 'Togo'],
  ['5W1', 'Samoa'],
  ['5X5', 'Uganda'],
  ['5Z4', 'Kenya'],
  ['6W1', 'Senegal'],
  ['6Y5', 'Jamaica'],
  ['7O2', 'Yemen'],
  ['7P8', 'Lesotho'],
  ['7Q7', 'Malawi'],
  ['7X0', 'Algeria'],
  ['7Z1', 'Saudi Arabia'],
  ['8P6', 'Barbados'],
  ['8Q7', 'Maldives'],
  ['8R1', 'Guyana'],
  ['9G1', 'Ghana'],
  ['9H1', 'Malta'],
  ['9J2', 'Zambia'],
  ['9K2', 'Kuwait'],
  ['9L1', 'Sierra Leone'],
  ['9M2', 'West Malaysia'],
  ['9M6', 'East Malaysia'],
  ['9N7', 'Nepal'],
  ['9Q5', 'Dem. Rep. of Congo'],
  ['9U5', 'Burundi'],
  ['9V1', 'Singapore'],
  ['9X0', 'Rwanda'],
  ['9Y4', 'Trinidad & Tobago'],

  // 3-character prefixes
  ['A22', 'Botswana'],
  ['A35', 'Tonga'],
  ['A45', 'Oman'],
  ['A52', 'Bhutan'],
  ['A61', 'United Arab Emirates'],
  ['A71', 'Qatar'],
  ['A92', 'Bahrain'],
  ['AP2', 'Pakistan'],
  ['BV9', 'Pratas Is.'],
  ['BY1', 'China'],
  ['C21', 'Nauru'],
  ['C31', 'Andorra'],
  ['C56', 'The Gambia'],
  ['C91', 'Mozambique'],
  ['CE0', 'Easter Is.'],
  ['CE9', 'Antarctica'],
  ['CN8', 'Morocco'],
  ['CO8', 'Cuba'],
  ['CP9', 'Bolivia'],
  ['CQ8', 'Azores'],
  ['CR3', 'Sao Tome & Principe'],
  ['CS2', 'Portugal'],
  ['CT3', 'Madeira Is.'],
  ['CU2', 'Azores'],
  ['CW5', 'Uruguay'],
  ['CX9', 'Uruguay'],
  ['D44', 'Cape Verde'],
  ['D68', 'Comoros'],
  ['DL0', 'Germany'],
  ['DU1', 'Philippines'],
  ['E30', 'Eritrea'],
  ['E44', 'Palestinian Authority'],
  ['E51', 'North Cook Is.'],
  ['E52', 'South Cook Is.'],
  ['EA6', 'Balearic Is.'],
  ['EA8', 'Canary Is.'],
  ['EA9', 'Ceuta & Melilla'],
  ['EK6', 'Armenia'],
  ['EL2', 'Liberia'],
  ['EP2', 'Iran'],
  ['ER1', 'Moldova'],
  ['ES1', 'Estonia'],
  ['ET3', 'Ethiopia'],
  ['EU1', 'Belarus'],
  ['EW1', 'Belarus'],
  ['EX8', 'Kyrgyzstan'],
  ['EY8', 'Tajikistan'],
  ['EZ8', 'Turkmenistan'],
  ['F6', 'France'],
  ['FK8', 'New Caledonia'],
  ['FM5', 'Martinique'],
  ['FO5', 'French Polynesia'],
  ['FR5', 'Reunion Is.'],
  ['FS5', 'St. Martin'],
  ['FW5', 'Wallis & Futuna Is.'],
  ['FY5', 'French Guiana'],
  ['G3', 'England'],
  ['GD3', 'Isle of Man'],
  ['GI3', 'Northern Ireland'],
  ['GJ2', 'Jersey'],
  ['GM3', 'Scotland'],
  ['GU3', 'Guernsey'],
  ['GW3', 'Wales'],
  ['H44', 'Solomon Is.'],
  ['HA5', 'Hungary'],
  ['HB0', 'Liechtenstein'],
  ['HB9', 'Switzerland'],
  ['HC8', 'Galapagos Is.'],
  ['HH2', 'Haiti'],
  ['HI8', 'Dominican Republic'],
  ['HK0', 'Malpelo Is.'],
  ['HK3', 'Colombia'],
  ['HL5', 'South Korea'],
  ['HO3', 'Panama'],
  ['HP3', 'Panama'],
  ['HR2', 'Honduras'],
  ['HS0', 'Thailand'],
  ['HV0', 'Vatican City'],
  ['HZ1', 'Saudi Arabia'],
  ['IS0', 'Sardinia'],
  ['IT9', 'Sicily'],
  ['J28', 'Djibouti'],
  ['J43', 'Greece'],
  ['J52', 'Guinea-Bissau'],
  ['J61', 'St. Lucia'],
  ['J73', 'Dominica'],
  ['J88', 'St. Vincent'],
  ['JD1', 'Ogasawara'],
  ['JT1', 'Mongolia'],
  ['JW5', 'Svalbard'],
  ['JX7', 'Jan Mayen'],
  ['JY4', 'Jordan'],
  ['KC4', 'Antarctica'],
  ['KC6', 'Micronesia'],
  ['KG4', 'Guantanamo Bay'],
  ['LA5', 'Norway'],
  ['LU5', 'Argentina'],
  ['LX1', 'Luxembourg'],
  ['LY2', 'Lithuania'],
  ['LZ1', 'Bulgaria'],
  ['M0', 'England'],
  ['MI0', 'Northern Ireland'],
  ['MJ0', 'Jersey'],
  ['MM0', 'Scotland'],
  ['MU0', 'Guernsey'],
  ['MW0', 'Wales'],
  ['OA4', 'Peru'],
  ['OE5', 'Austria'],
  ['OE3', 'Austria'],
  ['OG3', 'Finland'],
  ['OH3', 'Finland'],
  ['OH0', 'Aland Is.'],
  ['OJ0', 'Market Reef'],
  ['OK1', 'Czech Republic'],
  ['OM3', 'Slovakia'],
  ['ON4', 'Belgium'],
  ['OX3', 'Greenland'],
  ['OY3', 'Faroe Is.'],
  ['OZ5', 'Denmark'],
  ['P29', 'Papua New Guinea'],
  ['P40', 'Aruba'],
  ['P49', 'Aruba'],
  ['PA3', 'Netherlands'],
  ['PJ2', 'Curacao'],
  ['PJ4', 'Bonaire'],
  ['PJ5', 'Saba & St. Eustatius'],
  ['PJ7', 'Sint Maarten'],
  ['PY0', 'Fernando de Noronha'],
  ['PY5', 'Brazil'],
  ['PZ5', 'Suriname'],
  ['R0', 'Russia (Asia)'],
  ['RA9', 'Russia (Asia)'],
  ['RK9', 'Russia (Asia)'],
  ['RM9', 'Russia (Asia)'],
  ['S01', 'Western Sahara'],
  ['S21', 'Bangladesh'],
  ['S59', 'Slovenia'],
  ['S79', 'Seychelles'],
  ['S92', 'Sao Tome & Principe'],
  ['SM5', 'Sweden'],
  ['SP5', 'Poland'],
  ['ST2', 'Sudan'],
  ['SU1', 'Egypt'],
  ['SV1', 'Greece'],
  ['T30', 'W. Kiribati'],
  ['T31', 'C. Kiribati'],
  ['T32', 'E. Kiribati'],
  ['T33', 'Banaba Is.'],
  ['T6', 'Afghanistan'],
  ['T70', 'San Marino'],
  ['T77', 'San Marino'],
  ['T88', 'Palau'],
  ['T9', 'Bosnia-Herzegovina'],
  ['TA1', 'Turkey'],
  ['TF3', 'Iceland'],
  ['TG9', 'Guatemala'],
  ['TI5', 'Costa Rica'],
  ['TJ8', 'Cameroon'],
  ['TK5', 'Corsica'],
  ['TL8', 'Central Africa'],
  ['TN8', 'Republic of Congo'],
  ['TR8', 'Gabon'],
  ['TT8', 'Chad'],
  ['TU5', 'Cote dIvoire'],
  ['TY5', 'Benin'],
  ['TZ6', 'Mali'],
  ['UA1', 'Russia (Europe)'],
  ['UA2', 'Kaliningrad'],
  ['UA9', 'Russia (Asia)'],
  ['UK8', 'Uzbekistan'],
  ['UN7', 'Kazakhstan'],
  ['UY5', 'Ukraine'],
  ['V21', 'Antigua & Barbuda'],
  ['V26', 'Antigua & Barbuda'],
  ['V31', 'Belize'],
  ['V47', 'St. Kitts & Nevis'],
  ['V51', 'Namibia'],
  ['V55', 'Namibia'],
  ['V63', 'Micronesia'],
  ['V73', 'Marshall Is.'],
  ['V85', 'Brunei'],
  ['VE3', 'Canada'],
  ['VK2', 'Australia'],
  ['VP2E', 'Anguilla'],
  ['VP2M', 'Montserrat'],
  ['VP2V', 'British Virgin Is.'],
  ['VP5', 'Turks & Caicos Is.'],
  ['VP6', 'Pitcairn Is.'],
  ['VP8', 'Falkland Is.'],
  ['VP9', 'Bermuda'],
  ['VQ9', 'Chagos Is.'],
  ['VR2', 'Hong Kong'],
  ['VU2', 'India'],
  ['VU7', 'Lakshadweep Is.'],
  ['VK9', 'Australia (territories)'],
  ['XE1', 'Mexico'],
  ['XF4', 'Revillagigedo Is.'],
  ['XT2', 'Burkina Faso'],
  ['XU7', 'Cambodia'],
  ['XV9', 'Vietnam'],
  ['XW8', 'Laos'],
  ['XX9', 'Macao'],
  ['XZ1', 'Myanmar'],
  ['YA1', 'Afghanistan'],
  ['YB3', 'Indonesia'],
  ['YI1', 'Iraq'],
  ['YJ0', 'Vanuatu'],
  ['YK1', 'Syria'],
  ['YL2', 'Latvia'],
  ['YN2', 'Nicaragua'],
  ['YO8', 'Romania'],
  ['YS1', 'El Salvador'],
  ['YU1', 'Serbia'],
  ['YV5', 'Venezuela'],
  ['Z21', 'Zimbabwe'],
  ['Z29', 'Zimbabwe'],
  ['Z31', 'North Macedonia'],
  ['Z61', 'Kosovo'],
  ['Z81', 'South Sudan'],
  ['ZA1', 'Albania'],
  ['ZB2', 'Gibraltar'],
  ['ZC4', 'UK Sovereign Base Areas on Cyprus'],
  ['ZD7', 'St. Helena'],
  ['ZD8', 'Ascension Is.'],
  ['ZD9', 'Tristan da Cunha & Gough Is.'],
  ['ZF2', 'Cayman Is.'],
  ['ZK3', 'Tokelau Is.'],
  ['ZL7', 'Chatham Is.'],
  ['ZL8', 'Kermadec Is.'],
  ['ZL9', 'Campbell Is.'],
  ['ZL2', 'New Zealand'],
  ['ZP9', 'Paraguay'],
  ['ZS3', 'South Africa'],
  ['ZS6', 'South Africa'],
  ['ZS8', 'Prince Edward & Marion Is.'],

  // 2-character prefixes
  ['3A', 'Monaco'],
  ['3B', 'Mauritius'],
  ['3C', 'Equatorial Guinea'],
  ['3D', 'Fiji'],
  ['3G', 'Chile'],
  ['3W', 'Vietnam'],
  ['3X', 'Guinea'],
  ['3Y', 'Bouvet Is.'],
  ['3Z', 'Poland'],
  ['4J', 'Azerbaijan'],
  ['4K', 'Azerbaijan'],
  ['4L', 'Georgia'],
  ['4O', 'Montenegro'],
  ['4S', 'Sri Lanka'],
  ['4U', 'United Nations HQ'],
  ['4X', 'Israel'],
  ['4Z', 'Israel'],
  ['5A', 'Libya'],
  ['5B', 'Cyprus'],
  ['5H', 'Tanzania'],
  ['5N', 'Nigeria'],
  ['5R', 'Madagascar'],
  ['5T', 'Mauritania'],
  ['5U', 'Niger'],
  ['5V', 'Togo'],
  ['5W', 'Samoa'],
  ['5X', 'Uganda'],
  ['5Z', 'Kenya'],
  ['6W', 'Senegal'],
  ['6Y', 'Jamaica'],
  ['7O', 'Yemen'],
  ['7P', 'Lesotho'],
  ['7Q', 'Malawi'],
  ['7X', 'Algeria'],
  ['7Z', 'Saudi Arabia'],
  ['8P', 'Barbados'],
  ['8Q', 'Maldives'],
  ['8R', 'Guyana'],
  ['9A', 'Croatia'],
  ['9G', 'Ghana'],
  ['9H', 'Malta'],
  ['9J', 'Zambia'],
  ['9K', 'Kuwait'],
  ['9L', 'Sierra Leone'],
  ['9M', 'Malaysia'],
  ['9N', 'Nepal'],
  ['9Q', 'Dem. Rep. of Congo'],
  ['9U', 'Burundi'],
  ['9V', 'Singapore'],
  ['9X', 'Rwanda'],
  ['9Y', 'Trinidad & Tobago'],
  ['A2', 'Botswana'],
  ['A3', 'Tonga'],
  ['A4', 'Oman'],
  ['A5', 'Bhutan'],
  ['A6', 'United Arab Emirates'],
  ['A7', 'Qatar'],
  ['A9', 'Bahrain'],
  ['AP', 'Pakistan'],
  ['BV', 'Taiwan'],
  ['BY', 'China'],
  ['C2', 'Nauru'],
  ['C3', 'Andorra'],
  ['C5', 'The Gambia'],
  ['C6', 'Bahamas'],
  ['C9', 'Mozambique'],
  ['CE', 'Chile'],
  ['CM', 'Cuba'],
  ['CN', 'Morocco'],
  ['CO', 'Cuba'],
  ['CP', 'Bolivia'],
  ['CQ', 'Portugal'],
  ['CR', 'Portugal'],
  ['CS', 'Portugal'],
  ['CT', 'Portugal'],
  ['CU', 'Azores'],
  ['CW', 'Uruguay'],
  ['CX', 'Uruguay'],
  ['CY', 'Canada'],
  ['D2', 'Angola'],
  ['D3', 'Angola'],
  ['D4', 'Cape Verde'],
  ['D6', 'Comoros'],
  ['DL', 'Germany'],
  ['DU', 'Philippines'],
  ['E3', 'Eritrea'],
  ['E4', 'Palestinian Authority'],
  ['E5', 'Cook Is.'],
  ['E7', 'Bosnia-Herzegovina'],
  ['EA', 'Spain'],
  ['EI', 'Ireland'],
  ['EK', 'Armenia'],
  ['EL', 'Liberia'],
  ['EP', 'Iran'],
  ['ER', 'Moldova'],
  ['ES', 'Estonia'],
  ['ET', 'Ethiopia'],
  ['EU', 'Belarus'],
  ['EW', 'Belarus'],
  ['EX', 'Kyrgyzstan'],
  ['EY', 'Tajikistan'],
  ['EZ', 'Turkmenistan'],
  ['F', 'France'],
  ['G', 'England'],
  ['GD', 'Isle of Man'],
  ['GI', 'Northern Ireland'],
  ['GJ', 'Jersey'],
  ['GM', 'Scotland'],
  ['GU', 'Guernsey'],
  ['GW', 'Wales'],
  ['H4', 'Solomon Is.'],
  ['H7', 'Nicaragua'],
  ['H8', 'Panama'],
  ['HA', 'Hungary'],
  ['HB', 'Switzerland'],
  ['HC', 'Ecuador'],
  ['HH', 'Haiti'],
  ['HI', 'Dominican Republic'],
  ['HK', 'Colombia'],
  ['HL', 'South Korea'],
  ['HO', 'Panama'],
  ['HP', 'Panama'],
  ['HR', 'Honduras'],
  ['HS', 'Thailand'],
  ['HV', 'Vatican City'],
  ['HZ', 'Saudi Arabia'],
  ['I', 'Italy'],
  ['IS', 'Sardinia'],
  ['IT', 'Sicily'],
  ['J2', 'Djibouti'],
  ['J3', 'Grenada'],
  ['J5', 'Guinea-Bissau'],
  ['J6', 'St. Lucia'],
  ['J7', 'Dominica'],
  ['J8', 'St. Vincent'],
  ['JA', 'Japan'],
  ['JD', 'Japan (Ogasawara)'],
  ['JT', 'Mongolia'],
  ['JW', 'Svalbard'],
  ['JX', 'Jan Mayen'],
  ['JY', 'Jordan'],
  ['K', 'United States'],
  ['KA', 'United States'],
  ['KB', 'United States'],
  ['KC', 'United States'],
  ['KD', 'United States'],
  ['KE', 'United States'],
  ['KF', 'United States'],
  ['KG', 'United States'],
  ['KI', 'United States'],
  ['KJ', 'United States'],
  ['KK', 'United States'],
  ['KM', 'United States'],
  ['KN', 'United States'],
  ['KO', 'United States'],
  ['KQ', 'United States'],
  ['KR', 'United States'],
  ['KS', 'United States'],
  ['KT', 'United States'],
  ['KU', 'United States'],
  ['KV', 'United States'],
  ['KW', 'United States'],
  ['KX', 'United States'],
  ['KY', 'United States'],
  ['KZ', 'United States'],
  ['LA', 'Norway'],
  ['LB', 'Norway'],
  ['LC', 'Norway'],
  ['LD', 'Norway'],
  ['LE', 'Norway'],
  ['LF', 'Norway'],
  ['LG', 'Norway'],
  ['LH', 'Norway'],
  ['LI', 'Norway'],
  ['LJ', 'Norway'],
  ['LK', 'Norway'],
  ['LL', 'Norway'],
  ['LM', 'Norway'],
  ['LN', 'Norway'],
  ['LU', 'Argentina'],
  ['LV', 'Argentina'],
  ['LW', 'Argentina'],
  ['LX', 'Luxembourg'],
  ['LY', 'Lithuania'],
  ['LZ', 'Bulgaria'],
  ['M', 'England'],
  ['MI', 'Northern Ireland'],
  ['MJ', 'Jersey'],
  ['MM', 'Scotland'],
  ['MU', 'Guernsey'],
  ['MW', 'Wales'],
  ['N', 'United States'],
  ['OA', 'Peru'],
  ['OB', 'Peru'],
  ['OC', 'Peru'],
  ['OD', 'Lebanon'],
  ['OE', 'Austria'],
  ['OF', 'Finland'],
  ['OG', 'Finland'],
  ['OH', 'Finland'],
  ['OI', 'Finland'],
  ['OJ', 'Finland'],
  ['OK', 'Czech Republic'],
  ['OL', 'Czech Republic'],
  ['OM', 'Slovakia'],
  ['ON', 'Belgium'],
  ['OO', 'Belgium'],
  ['OP', 'Belgium'],
  ['OQ', 'Belgium'],
  ['OR', 'Belgium'],
  ['OS', 'Belgium'],
  ['OT', 'Belgium'],
  ['OU', 'Denmark'],
  ['OV', 'Denmark'],
  ['OW', 'Denmark'],
  ['OX', 'Greenland'],
  ['OY', 'Faroe Is.'],
  ['OZ', 'Denmark'],
  ['P2', 'Papua New Guinea'],
  ['P4', 'Aruba'],
  ['PA', 'Netherlands'],
  ['PB', 'Netherlands'],
  ['PC', 'Netherlands'],
  ['PD', 'Netherlands'],
  ['PE', 'Netherlands'],
  ['PF', 'Netherlands'],
  ['PG', 'Netherlands'],
  ['PH', 'Netherlands'],
  ['PI', 'Netherlands'],
  ['PJ', 'Netherlands Antilles'],
  ['PY', 'Brazil'],
  ['PZ', 'Suriname'],
  ['R', 'Russia'],
  ['RA', 'Russia'],
  ['RB', 'Russia'],
  ['RC', 'Russia'],
  ['RD', 'Russia'],
  ['RE', 'Russia'],
  ['RF', 'Russia'],
  ['RG', 'Russia'],
  ['RJ', 'Russia'],
  ['RK', 'Russia'],
  ['RL', 'Russia'],
  ['RM', 'Russia'],
  ['RN', 'Russia'],
  ['RO', 'Russia'],
  ['RP', 'Russia'],
  ['RQ', 'Russia'],
  ['RR', 'Russia'],
  ['RS', 'Russia'],
  ['RT', 'Russia'],
  ['RU', 'Russia'],
  ['RV', 'Russia'],
  ['RW', 'Russia'],
  ['RX', 'Russia'],
  ['RY', 'Russia'],
  ['RZ', 'Russia'],
  ['S0', 'Western Sahara'],
  ['S2', 'Bangladesh'],
  ['S5', 'Slovenia'],
  ['S7', 'Seychelles'],
  ['S9', 'Sao Tome & Principe'],
  ['SK', 'Sweden'],
  ['SL', 'Sweden'],
  ['SM', 'Sweden'],
  ['SN', 'Poland'],
  ['SO', 'Poland'],
  ['SP', 'Poland'],
  ['SQ', 'Poland'],
  ['SR', 'Poland'],
  ['ST', 'Sudan'],
  ['SU', 'Egypt'],
  ['SV', 'Greece'],
  ['SW', 'Greece'],
  ['SX', 'Greece'],
  ['SY', 'Greece'],
  ['SZ', 'Greece'],
  ['T2', 'Tuvalu'],
  ['T3', 'Kiribati'],
  ['T6', 'Afghanistan'],
  ['T7', 'San Marino'],
  ['T8', 'Palau'],
  ['T9', 'Bosnia-Herzegovina'],
  ['TA', 'Turkey'],
  ['TB', 'Turkey'],
  ['TC', 'Turkey'],
  ['TF', 'Iceland'],
  ['TG', 'Guatemala'],
  ['TI', 'Costa Rica'],
  ['TJ', 'Cameroon'],
  ['TK', 'Corsica'],
  ['TL', 'Central Africa'],
  ['TN', 'Republic of Congo'],
  ['TR', 'Gabon'],
  ['TT', 'Chad'],
  ['TU', 'Cote dIvoire'],
  ['TY', 'Benin'],
  ['TZ', 'Mali'],
  ['UA', 'Russia'],
  ['UB', 'Russia'],
  ['UC', 'Russia'],
  ['UD', 'Russia'],
  ['UE', 'Russia'],
  ['UF', 'Russia'],
  ['UG', 'Russia'],
  ['UH', 'Russia'],
  ['UI', 'Russia'],
  ['UK', 'Uzbekistan'],
  ['UL', 'Russia'],
  ['UM', 'Russia'],
  ['UN', 'Kazakhstan'],
  ['UO', 'Ukraine'],
  ['UP', 'Kazakhstan'],
  ['UQ', 'Russia'],
  ['UR', 'Ukraine'],
  ['US', 'Ukraine'],
  ['UT', 'Ukraine'],
  ['UU', 'Ukraine'],
  ['UV', 'Ukraine'],
  ['UW', 'Ukraine'],
  ['UX', 'Ukraine'],
  ['UY', 'Ukraine'],
  ['UZ', 'Ukraine'],
  ['V2', 'Antigua & Barbuda'],
  ['V3', 'Belize'],
  ['V4', 'St. Kitts & Nevis'],
  ['V5', 'Namibia'],
  ['V6', 'Micronesia'],
  ['V7', 'Marshall Is.'],
  ['V8', 'Brunei'],
  ['VE', 'Canada'],
  ['VK', 'Australia'],
  ['VO', 'Canada'],
  ['VP', 'Various British Territories'],
  ['VQ', 'Various British Territories'],
  ['VR', 'Hong Kong'],
  ['VS', 'Various British Territories'],
  ['VU', 'India'],
  ['VY', 'Canada'],
  ['W', 'United States'],
  ['WA', 'United States'],
  ['WB', 'United States'],
  ['WC', 'United States'],
  ['WD', 'United States'],
  ['WE', 'United States'],
  ['WF', 'United States'],
  ['WG', 'United States'],
  ['WH', 'United States'],
  ['WI', 'United States'],
  ['WJ', 'United States'],
  ['WK', 'United States'],
  ['WL', 'United States'],
  ['WM', 'United States'],
  ['WN', 'United States'],
  ['WO', 'United States'],
  ['WP', 'United States'],
  ['WQ', 'United States'],
  ['WR', 'United States'],
  ['WS', 'United States'],
  ['WT', 'United States'],
  ['WU', 'United States'],
  ['WV', 'United States'],
  ['WW', 'United States'],
  ['WX', 'United States'],
  ['WY', 'United States'],
  ['WZ', 'United States'],
  ['XE', 'Mexico'],
  ['XF', 'Mexico'],
  ['XT', 'Burkina Faso'],
  ['XU', 'Cambodia'],
  ['XV', 'Vietnam'],
  ['XW', 'Laos'],
  ['XX', 'Macao'],
  ['XZ', 'Myanmar'],
  ['YA', 'Afghanistan'],
  ['YB', 'Indonesia'],
  ['YC', 'Indonesia'],
  ['YD', 'Indonesia'],
  ['YE', 'Indonesia'],
  ['YF', 'Indonesia'],
  ['YG', 'Indonesia'],
  ['YH', 'Indonesia'],
  ['YI', 'Iraq'],
  ['YJ', 'Vanuatu'],
  ['YK', 'Syria'],
  ['YL', 'Latvia'],
  ['YM', 'Turkey'],
  ['YN', 'Nicaragua'],
  ['YO', 'Romania'],
  ['YP', 'Romania'],
  ['YQ', 'Romania'],
  ['YR', 'Romania'],
  ['YS', 'El Salvador'],
  ['YT', 'Serbia'],
  ['YU', 'Serbia'],
  ['YV', 'Venezuela'],
  ['YW', 'Venezuela'],
  ['YX', 'Venezuela'],
  ['YY', 'Venezuela'],
  ['Z2', 'Zimbabwe'],
  ['Z3', 'North Macedonia'],
  ['Z6', 'Kosovo'],
  ['Z8', 'South Sudan'],
  ['ZA', 'Albania'],
  ['ZB', 'Gibraltar'],
  ['ZC', 'UK Sovereign Base Areas on Cyprus'],
  ['ZD', 'St. Helena'],
  ['ZE', 'Zimbabwe'],
  ['ZF', 'Cayman Is.'],
  ['ZK', 'Cook Is.'],
  ['ZL', 'New Zealand'],
  ['ZM', 'New Zealand'],
  ['ZP', 'Paraguay'],
  ['ZR', 'South Africa'],
  ['ZS', 'South Africa'],
  ['ZT', 'South Africa'],
  ['ZU', 'South Africa'],
  ['ZV', 'Brazil'],
  ['ZW', 'Brazil'],
  ['ZX', 'Brazil'],
  ['ZY', 'Brazil'],
  ['ZZ', 'Brazil'],
];

// Sort longest prefix first to ensure most-specific match wins
DXCC_PREFIXES.sort((a, b) => b[0].length - a[0].length);

/**
 * Derive DXCC country from a callsign using prefix matching.
 * Strips portable designators (/P, /M, /MM, /AM, /QRP, /digit) before matching.
 * Returns country string or null if no match found.
 */
export function getDxCountry(callsign) {
  if (!callsign) return null;

  // Normalize: uppercase, strip common portable suffixes
  let call = callsign.toUpperCase().trim();

  // Remove trailing /P /M /MM /AM /QRP and single-digit suffixes like /5
  call = call.replace(/\/(P|M|MM|AM|QRP|\d)$/, '');

  // If there's a prefix designator (e.g. W1AW/KH6 → use KH6 as the call area)
  const slashIdx = call.lastIndexOf('/');
  if (slashIdx !== -1) {
    const suffix = call.slice(slashIdx + 1);
    const prefix = call.slice(0, slashIdx);
    // If suffix looks like a call area prefix (1-4 chars, letters+digits), use it
    if (suffix.length <= 4 && /^[A-Z0-9]+$/.test(suffix)) {
      call = suffix.length >= prefix.length ? suffix : prefix;
    }
  }

  for (const [prefix, country] of DXCC_PREFIXES) {
    if (call.startsWith(prefix)) return country;
  }

  return null;
}

export default DXCC_PREFIXES;
